import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Login} from '@core/modules/authentication/interfaces/login.interface';
import {HttpHelper} from '@shared/helpers/http.helper';
import {TokenService} from '@core/modules/authentication/services/token.service';
import {API_AUTH_LOGIN, API_AUTH_LOGOUT, getEndpoint} from '@core/constants/api';
import {LOGIN_ROUTE} from '@core/constants/navigation/navigation.const';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService extends HttpHelper {
  private _isAuthorize: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.token.isToken);

  constructor(
    private router: Router,
    public token: TokenService
  ) {
    super();
  }

  private unAuthorize(): void {
    this.token.removeToken();
    this.isAuthorize = false;
  }

  public login(loginData: Login): Promise<any> {
    const { email, password } = loginData;
    return this.post(getEndpoint(API_AUTH_LOGIN), { email, password }).toPromise();
  }

  public logout(redirect: boolean = true): void {
    this.Post(getEndpoint(API_AUTH_LOGOUT), null);
    this.softLogout(redirect);
  }

  public softLogout(redirect: boolean = true): void {
    this.unAuthorize();

    if (redirect) {
      this.router.navigateByUrl(LOGIN_ROUTE);
    }
  }

  set isAuthorize(isAuthorize: boolean) {
    this._isAuthorize.next(isAuthorize);
  }

  get isAuthorize(): boolean {
    return this._isAuthorize.getValue();
  }

  get isAuthorize$(): Observable<boolean> {
    return this._isAuthorize.asObservable();
  }
}
